<template>
  <div class="page-header">
    <div class="header clearFloat">
      <div class="logo clearFloat">
        <img v-if="LogoImg != ''" :src="LogoImg" alt />
        <img v-else src="../../assets/small-logo.svg" alt />
        <!-- <img src="../../assets/small-logo.svg" alt>        -->

        <span class="system-title">{{ $t("Header.title") }}</span>
      </div>
      <!-- <div class="head-line"></div> -->
      <!-- 折叠按钮 -->
      <div class="collapse-btn" @click="collapseChage">
        <i class="icon-menu">
          <img src="../../assets/images/icon/icon-menu.png" alt />
        </i>
      </div>
      <div class="header-middle" v-if="!hideMenu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" v-show="status == '1'">
            <div>
              <i class="crm-yw-gl"></i>
              {{ $t("Header.menu1") }}
            </div>
          </el-menu-item>
          <el-menu-item index="2">
            <div>
              <i class="crmIcon-zscrm"></i>
              {{ $t("Header.menu2") }}
            </div>
          </el-menu-item>
          <el-menu-item index="3" v-if="!isOffical">
            <div>
              <i class="crm-home-"></i>
              {{ $t("Header.menu3") }}
            </div>
          </el-menu-item>
          <!-- <el-menu-item index="4">
            <div>
              <i class="el-icon-setting"></i>
              {{ $t("Header.menu4") }}
            </div>
          </el-menu-item> -->
        </el-menu>
      </div>
      <div class="header-right">
        <div class="header-user-con">
          <div>
            <el-input
              prefix-icon="el-icon-search"
              class="filterName"
              :placeholder="$t('Header.searchTxt')"
              size="small"
              @focus="handleNameFocus"
            ></el-input>
          </div>
          <!-- 简繁文切换 -->
          <!-- 
          <div class="languag-change text-1">
            <span :class="{'active':languageType=='zh'}" @click="handleCommandLanguage('zh')">简</span>
            <span class="line"></span>
            <span :class="{'active':languageType=='tw'}" @click="handleCommandLanguage('tw')">繁</span>
          </div>
          -->
          <!-- 吉的堡园分校显示 -->
          <div v-if="school != ''" class="btn-fullscreen" @click="showSchool()">
            <el-tooltip
              class="item"
              effect="dark"
              :content="school"
              placement="bottom"
            >
              <span>{{ school }}</span>
            </el-tooltip>
          </div>
          <!-- 学校切换 -->
          <div v-if="school != ''" class="btn-bell">
            <span placement="bottom">
              <i
                class="ml5"
                :class="[rotate ? 'el-icon-refresh go' : 'el-icon-refresh aa']"
                @click="showSchool()"
              ></i>
              <span
                style="font-size: 12px; display: inline-block; margin-left: 5px"
                @click="showSchool()"
                >{{ $t("Header.exchange") }}</span
              >
            </span>
          </div>
          <!-- 消息通知********暂时隐藏 -->
          <!-- <el-badge :value="3" class="item">
            <i class="el-icon-message" @click="showMemessage=true"></i>
          </el-badge>-->
          <!-- 用户头像 -->
          <el-dropdown
            class="user-name"
            trigger="click"
            @command="handleCommand"
          >
            <div class="dropdown-title">
              <div class="user-avator">
                <img
                  v-if="
                    myinfoform.marketer_img && myinfoform.marketer_img != ''
                  "
                  :src="myinfoform.marketer_img"
                />
                <img
                  v-else-if="myinfoform.staffer_sex == $t('Common.woman')"
                  :src="photoImgWomen"
                />
                <img v-else :src="photoImgmen" />
              </div>
              <span class="dropdown-name">{{ userName }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided command="myinfo">{{
                $t("Header.dropdown_item1")
              }}</el-dropdown-item>
              <el-dropdown-item divided command="contact">{{
                $t("Header.dropdown_item2")
              }}</el-dropdown-item>
              <el-dropdown-item divided command="exchange">{{
                $t("Header.dropdown_item3")
              }}</el-dropdown-item>
              <el-dropdown-item divided command="loginout">{{
                $t("Header.dropdown_item4")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 用户名下拉菜单 -->
          <!-- <el-dropdown class="user-name" trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">{{userName}}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided command="myinfo">个人信息</el-dropdown-item>
              <el-dropdown-item divided command="contact">联系人</el-dropdown-item>
              <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
        </div>
      </div>
    </div>
    <!-- 学校选择边栏 start-->
    <el-dialog
      :title="$t('Header.s_title1')"
      :visible.sync="selectSchool"
      class="tan-select-school"
      width="50%"
      :before-close="handleClose"
    >
      <div class="select-school-cont">
        <!-- <p class="title-cont">请选择您要进入的学校</p> -->
        <el-form label="90px" class="clearFloat">
          <el-select
            filterable
            v-model="form.district_id"
            style="width: 25%; margin-right: 2%"
            :placeholder="$t('Header.placeholder1')"
            class="pull-left"
            @change="SelectOrganiza"
          >
            <el-option
              v-for="item in areaList"
              :key="item.district_id"
              :label="item.district_cnname"
              :value="item.district_id"
            ></el-option>
          </el-select>
          <el-select
            filterable
            v-model="form.province"
            style="width: 15%"
            :placeholder="$t('Header.placeholder2')"
            class="pull-left"
            @change="getCityData"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.region_id"
              :label="item.region_name"
              :value="item.region_id"
            ></el-option>
          </el-select>
          <el-select
            filterable
            v-model="form.city"
            style="width: 15%; margin-left: 2%"
            :placeholder="$t('Header.placeholder3')"
            class="pull-left"
            @change="SelectCity"
          >
            <el-option
              v-for="item in cityList"
              :key="item.region_id"
              :label="item.region_name"
              :value="item.region_id"
            ></el-option>
          </el-select>
          <!-- <el-select filterable
            v-model="form.organization"
            style="width: 25%;margin-left:2%;"
            placeholder="选择机构组织"
            class="pull-left"
            @change="SelectOrganiza"
          >
            <el-option
              v-for="item in organizationList"
              :key="item.organize_id"
              :label="item.organize_cnname"
              :value="item.organize_id"
            ></el-option>
          </el-select>-->
          <el-input
            type="search"
            class="pull-right"
            style="width: 40%"
            :placeholder="$t('Header.placeholder4')"
            v-model="form.keyword"
            @keyup.enter.native="SelectKeyword()"
          >
            <i
              slot="suffix"
              class="el-icon-search"
              style="cursor: pointer; line-height: 30px"
              @click="SelectKeyword()"
            ></i>
          </el-input>
        </el-form>
        <div class="school clearFloat">
          <div class="school-list pull-left">
            <div
              class="list-item"
              v-for="(item1, index1) in schoolList"
              :key="index1"
            >
              <div class="title">{{ item1.companyName }}</div>
              <ul class="list">
                <!-- <li
                  v-for="(item1,index1) in schoolList"
                  :key="index1"
                  @click="selSchool(index1,item1.school_cnname,item1.school_id)"
                  :class="{active:index1==current}"
                >{{item1.school_cnname}}</li>-->
                <li
                  v-for="(item2, index2) in item1.list"
                  :key="index2"
                  @click="selSchool(index1, index2, item1, item2)"
                  @dblclick="dbSelSchool(index1, index2, item1, item2)"
                  :class="{
                    active: index2 == current && pagecurrent == index1,
                  }"
                >
                  {{ item2.school_shortname }}&nbsp;&nbsp;({{
                    item2.school_branch
                  }})
                </li>
              </ul>
            </div>
          </div>
          <div class="letter pull-right">
            <ul>
              <li
                v-for="(item1, index1) in letter1"
                :key="index1"
                @click="SelectLetter(item1)"
              >
                <span>{{ item1 }}</span>
              </li>
            </ul>
            <ul>
              <li
                v-for="(item2, index2) in letter2"
                :key="index2"
                @click="SelectLetter(item2)"
              >
                <span>{{ item2 }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="HandleButton">{{
          $t("Common.btn_complete")
        }}</el-button>
        <el-button @click="handhideSchool()">{{
          $t("Common.btn_cancel")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 消息侧边栏 -->
    <SliderBox
      :showSliderBox="showMemessage"
      @hideSliderBox="hideMemessageBox"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Header.message_labe1") }}
          </p>
          <div class="pull-right h1 font-gray" @click="hideMemessageBox">
            <i class="crm-tz"></i>
          </div>
          <!-- <el-button type="primary" class="pull-right">确定</el-button> -->
        </div>
        <div class="slider-cont text-1">
          <div class="message-title clearFloat">
            <p class="pull-left">{{ $t("Header.message_labe1") }}</p>
            <p class="pull-right font-lightgray">
              {{ $t("Header.message_labe2") }}
            </p>
          </div>
          <div
            class="row-message"
            v-for="(item, index) in messageList"
            :key="index"
          >
            <div class="top clearFloat">
              <span
                class="span-message"
                :class="{ 'sapn-warning': item.isWarning }"
                >{{ item.messageTab }}</span
              >
              <p class="time pull-right font-lightgray">{{ item.time }}</p>
            </div>
            <div class="message-cont">
              <span>{{ item.cont }}</span>
              <span v-if="item.isRemid">{{ $t("Header.message_labe3") }}</span>
            </div>
          </div>
        </div>
      </div>
    </SliderBox>

    <!-- 联系人侧边栏showContact -->
    <SliderBox
      :showSliderBox="showContact"
      @hideSliderBox="hideshowContactBox"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain">
        <div class="slider-top clearFloat">
          <div
            class="pull-right h1 font-gray btn-back"
            @click="hideshowContactBox"
          >
            <i class="el-icon-close"></i>
          </div>
          <p class="h3 slider-title pull-left">
            {{ $t("Header.contact_label1") }}
          </p>
          <!-- <el-button type="primary" class="pull-right">确定</el-button> -->
        </div>
        <div class="slider-cont text-1">
          <div
            class="contact-cont"
            v-for="(item1, index1) in LinkmanList"
            :key="index1"
          >
            <!-- <p>{{item1.departmentName}}</p> -->
            <div class="contact">
              <el-row
                class="row-contact"
                v-for="(item2, index2) in item1.list"
                :key="index2"
              >
                <el-col :span="4">
                  <div class="grid-img">
                    <img
                      v-if="item2.staffer_img != ''"
                      :src="item2.staffer_img"
                    />
                    <img
                      v-if="
                        item2.staffer_img == '' &&
                        item2.staffer_sex == $t('Common.man')
                      "
                      :src="photoImgmen"
                    />
                    <img
                      v-if="
                        item2.staffer_img == '' &&
                        item2.staffer_sex != $t('Common.man')
                      "
                      :src="photoImgWomen"
                    />
                  </div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content">
                    <p class="name">
                      {{ item2.staffer_cnname }}
                      <template
                        v-if="
                          item2.staffer_enname && item2.staffer_enname != ''
                        "
                        >({{ item2.staffer_enname }})</template
                      >
                      <img
                        v-if="item2.staffer_sex == $t('Common.man')"
                        :src="iconmen"
                      />
                      <img
                        v-if="item2.staffer_sex == $t('Common.woman')"
                        :src="iconWommen"
                      />
                      <span v-if="item2.post_name != '待定'">{{
                        item2.post_name
                      }}</span>
                    </p>
                    <p class="phone">{{ item2.staffer_mobile }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </SliderBox>
    <!-- 个人信息侧边栏 -->
    <!-- 联系人侧边栏showContact -->
    <SliderBox
      :showSliderBox="showMyinfo"
      @hideSliderBox="hideshowMyinfoBox"
      :sliderWidth="myinfosliderWidth"
    >
      <div class="silder-contain">
        <div class="slider-top slider-top-info clearFloat slider-top-create">
          <p class="h3 slider-title pull-left">
            {{ $t("Header.myInfo_label1") }}
          </p>
          <!-- <div class="pull-right h1 btn-close font-gray" @click="hideshowMyinfoBox">X</div> -->
          <div class="slider-close pull-right" @click="oninfoSubmit()">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="slider-cont text-1 myinfo-slider-cont">
          <el-form ref="myinfoform" :model="myinfoform" label-width="100px">
            <p class="form-small-title h3">{{ $t("Header.myInfo_label2") }}</p>
            <div class="base-info">
              <el-form-item :label="$t('Header.label_text1')">
                <el-input
                  v-model="myinfoform.marketer_name"
                  :disabled="true"
                  style="width: 300px"
                  :placeholder="$t('Header.info_placeholder1')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('Header.label_text2')">
                <el-input
                  v-model="myinfoform.marketer_mobile"
                  :disabled="true"
                  style="width: 300px"
                  :placeholder="$t('Header.info_placeholder2')"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="性别：">
                <el-input v-model="myinfoform.staffer_se手机号x" :disabled="true" style="width: 300px;" placeholder="请输入性别"></el-input>
              </el-form-item>
              <el-form-item label="出生日期：">
                <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="myinfoform.staffer_birthday"
                style="width: 300px;"
                value-format="yyyy-MM-dd"
                :disabled="true"
              ></el-date-picker>
              </el-form-item>-->
              <el-form-item :label="$t('Header.label_text3')">
                <el-upload
                  class="upload-demo"
                  style="width: 300px"
                  :disabled="true"
                  drag
                  :action="$uploadAction('/Uploading/Picture')"
                  multiple
                >
                  <img
                    class="myinfo-photo-img"
                    v-if="
                      myinfoform.marketer_img && myinfoform.marketer_img != ''
                    "
                    :src="myinfoform.marketer_img"
                  />
                  <img
                    class="myinfo-photo-img"
                    v-else-if="myinfoform.staffer_sex == $t('Common.woman')"
                    :src="photoImgWomen"
                  />
                  <img class="myinfo-photo-img" v-else :src="photoImgmen" />
                  <!-- <i class="el-icon-upload"></i>
                  <div class="el-upload__text">点击或图片拖曳到此处上传<br>支持png，jpg等图片</div>-->
                  <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </el-form-item>
            </div>
            <!-- <p class="form-small-title h3">账号信息</p>
            <div class="account-info">
              <el-form-item label="账号：">
                <p>{{myinfoform.staffer_branch}}</p>
              </el-form-item>
              <el-form-item label="手机号：">
                <p>{{myinfoform.marketer_mobile}}</p>
              </el-form-item>
            </div>-->
          </el-form>
        </div>
      </div>
    </SliderBox>
    <!-- 学校选择边栏 end-->

    <!-- 选择职务开始 -->
    <el-dialog
      :title="$t('Common.tips')"
      :visible.sync="exchangeRoleVis"
      class="tan-select-school"
      width="40%"
      :before-close="handleClose"
    >
      <div class="role__list">
        <div class="role_list__head">
          <div class="h_lf">
            <em>*</em>
            {{ $t("Header.post_label1") }}
          </div>
          <div class="h_rt">
            <em>*</em>
            {{ $t("Header.post_label2") }}
          </div>
        </div>
        <div class="role_list__cont">
          <div class="items" v-for="(item, index) in role_list" :key="index">
            <div class="tit">
              <p
                @click="radioIndex = item.postbe_id"
                :style="{
                  'background-color':
                    item.postbe_id == radioIndex ? '#20A8D8' : '',
                }"
              >
                {{ item.school_cnname }}
              </p>
            </div>
            <div class="selects">
              <el-radio-group v-model="radioIndex">
                <el-radio disabled :label="item.postbe_id">{{
                  item.post_name
                }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          @click="choosePost"
          class="revise exchange_btn"
          >{{ $t("Common.btn_confirm") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 更多按钮 -->
    <div
      class="slider_nav_box"
      :style="{
        right: showSliderNav ? '0px' : '-56px',
      }"
    >
      <el-tooltip :content="showSliderNav ? '收起' : '展开'" placement="left">
        <div class="arrow" @click="toggleShowNav" style="color: #000">
          <span
            style="color: #fff"
            :class="[
              showSliderNav ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left',
            ]"
          ></span>
        </div>
      </el-tooltip>
      <div class="items" @click="linkToChoose">
        <span class="icon icon_1"></span>
        <span class="txt">{{ $t("Header.slider_nav_name1") }}</span>
      </div>
      <div class="items" @click="showVideo">
        <span class="icon icon_2"></span>
        <span class="txt">{{ $t("Header.slider_nav_name2") }}</span>
      </div>
      <router-link :to="{ path: '/' }" tag="div" class="items">
        <span class="icon icon_3"></span>
        <span class="txt">{{ $t("Header.slider_nav_name3") }}</span>
      </router-link>
      <div class="items" @click="checkTxt">
        <span class="icon icon_4"></span>
        <span class="txt">{{ $t("Header.slider_nav_name4") }}</span>
      </div>
      <a
        target="_blank"
        href="https://chat.meiqia.cn/widget/standalone.html?eid=1952d70c7df8c2a9bb135fe1c34a3fd3"
        class="items"
      >
        <span class="icon icon_0"></span>
        <span class="txt">{{ $t("Header.slider_nav_name5") }}</span>
      </a>
    </div>
    <!-- 教学视频 -->
    <el-dialog
      :title="$t('Header.video_title')"
      :visible.sync="showChooseVideo"
      class="tan-select-school"
      width="950px"
      :before-close="handleClose"
    >
      <div class="choose_video__list">
        <template v-for="(item, index) in videoList">
          <div
            class="vitem"
            @click="viewDetail(item)"
            :key="index"
            v-if="item.handbook_videourl"
          >
            <!-- <video controls :src="item.handbook_videourl"></video> -->
            <img
              :src="`${item.handbook_videourl}?x-oss-process=video/snapshot,t_15000,m_fast`"
              alt
            />
            <p>{{ item.handbook_name }}</p>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChooseVideo = false">{{
          $t("Common.btn_cancel")
        }}</el-button>
      </span>
    </el-dialog>

    <template v-if="videoViewData.data">
      <el-dialog
        :title="videoViewData.data.handbook_name"
        :visible.sync="videoViewData.visible"
        class="tan-select-school"
        width="1000px"
        :before-close="handleClose"
      >
        <div class="view_video__container">
          <video
            controls
            autoplay
            :src="videoViewData.data.handbook_videourl"
            :poster="`${videoViewData.data.handbook_videourl}?x-oss-process=video/snapshot,t_15000,m_fast`"
          ></video>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="videoViewData.visible = false">取 消</el-button>
        </span>
      </el-dialog>
    </template>

    <template v-if="filterName.visible">
      <el-dialog
        :title="filterName.title"
        :visible.sync="filterName.visible"
        class="tan-select-school"
        width="1100px"
      >
        <div class="listSearch-container">
          <div class="content pl20 pr20">
            <div class="mb10">
              <el-input
                clearable
                :placeholder="$t('Admissioncue.dss')"
                class="input-cont input-keword"
                style="width: 500px !important"
                @change="handleSelectKeyword()"
                v-model="selectForm.keyword"
              ></el-input>
              <el-button
                type="primary"
                class="btn-inquire"
                @click="handleSelectKeyword()"
                >{{ $t("Admissioncue.ap") }}</el-button
              >
              <!-- <div class="btn-advancedFiter font-gray">
                    <i class="fiter-advance">
                      <img src="../../assets/images/filter.png" alt>
                    </i>
                    高级筛选
                  </div>-->
              <!-- <el-button type="primary">转回招生线索</el-button> -->
            </div>

            <normalTableCont
              :tableData="tableList"
              @handleColumnChange="handleColumnChange"
            >
            </normalTableCont>

            <!-- <el-pagination
                style="margin-top: 35px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30,40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>-->
          </div>
        </div>
      </el-dialog>
    </template>

    <!-- 文档 -->
    <SliderBox
      :showSliderBox="showChooseTxt"
      @hideSliderBox="hideShowTxt"
      :sliderWidth="myinWidth"
    >
      <div class="silder-contain">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Header.word_title1") }}
          </p>
          <div class="pull-right h1 font-gray btn-back" @click="hideShowTxt">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="slider-cont text-1">
          <div class="message-title clearFloat">
            <p class="pull-left">{{ $t("Header.word_title2") }}</p>
          </div>
          <div
            class="row-message"
            @click="checkDetail(item.handbook_id)"
            v-for="(item, index) in videoList"
            :key="index"
          >
            <div class="message-cont">
              <span>{{ item.handbook_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </SliderBox>
    <!-- 文档详情 -->
    <SliderBox
      :showSliderBox="hideShowTxtDetail"
      @hideSliderBox="showChooseTxtDetail"
      :sliderWidth="myanWidth"
    >
      <div class="right-slider-box">
        <div class="slider-header">
          <span class="h3">{{ $t("Header.word_title3") }}</span>
          <div
            class="pull-right h1 font-gray btn-back"
            @click="showChooseTxtDetail"
          >
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="slider-cont" v-if="txtContent">
          <p class="info-title h3">{{ txtContent.handbook_name }}</p>
          <div
            class="info-content mt20 h3"
            v-html="txtContent.handbook_note"
          ></div>
        </div>
      </div>
    </SliderBox>

    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="() => (showSliderBoxSee = false)"
      :sliderWidth="sliderWidth1"
    >
      <userSeeing
        :isTrack="isTrack"
        :ClassMessage="ClassMessage"
        :newclientTags="newclientTags"
        seeSliderTitle="查看名单"
        :customerId="customerId"
        :isAddTagVisible="false"
        :isHome="true"
        :activeName="activeName"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        @hideUserSliderBox="() => (showSliderBoxSee = false)"
        showAddTrack="true"
      ></userSeeing>
    </SliderBox>
  </div>
</template>

<script>
import storeHeard from "../common/Header.js";
import SliderBox from "../../components/SliderBox.vue";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";
import normalTableCont from "../../components/tables/switchTableCont.vue";
import userSeeing from "@/components/User/seeing.vue";
import {
  buildSystemHavePermissionUrl,
  buildChooseUrl,
  applySchoolSwitchContext,
} from "../../bootstrap/schoolSwitching";
import { STORAGE_KEYS } from "../../constants/storageKeys";
export default {
  data() {
    return {
      sliderWidth1: "800px",
      showSliderBoxSee: false,
      customerId: "",
      ClassMessage: {},
      iscanEdit: false,
      isRoot: false,
      isTrack: false,
      isFilter: false,
      activeName: "first",
      newclientTags: [],

      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: 500, //表格高度
          errortip: "",
          issetting: false,
        },
      },
      selectForm: {
        keyword: "",
      },
      filterName: {
        visible: false,
        title: "名单检索",
      },
      istemporaryclose: "",
      temporaryclosetip: "",

      videoViewData: {
        visible: false,
        data: null,
      },
      isOffical: true, // 是否正式服务
      showChooseVideo: false,
      showChooseTxt: false,
      hideShowTxtDetail: false,
      videoList: [],
      txtContent: null,
      myinWidth: "800px",
      myanWidth: "100%",
      // 是否切换
      isChange: false,

      // 角色
      radio: "",
      radioIndex: 0,
      role_list: [{ name: "", radio: "" }],
      exchangeRoleVis: false,

      showSliderBox: false,
      name: "Eric",
      message: 2,
      current: -1,
      school: "",
      schoolItem: "",
      schoolId: "", //暂存选择的school_id
      companyId: "", //暂存选择的company_id
      userName: "", //用户名
      LogoImg: "", //logo图片
      photoImg: require("../../assets/images/default-img.png"), //用户头像
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      photoImgWomen: require("../../assets/images/default-staff-women.png"), //默认女头像
      photoImgmen: require("../../assets/images/default-staff-men.png"), //默认男头像
      pagecurrent: -1,
      selectSchool: false,
      showMemessage: false,
      showContact: false,
      showMyinfo: false,
      sliderWidth: "500px",
      myinfosliderWidth: "700px",
      rotate: false,
      form: {
        province: "",
        city: "",
        organization: "",
        district_id: "",
        keyword: "",
        letter: "",
      },
      // 头部页面跳转信息
      UserTooke: "",
      UserLinkId: "",
      activeIndex2: "home",
      // 消息详情
      infomationData: [],
      //个人信息
      myinfoform: {
        marketer_name: "",
        staffer_sex: "",
        staffer_birthday: "",
        marketer_img: "",
        staffer_branch: "",
        marketer_mobile: "",
      },
      schoolList: [], //学校列表
      provinceList: [], //省份列表
      cityList: [], //城市列表
      areaList: [], //大区域
      organizationList: [], //组织列表
      messageList: [], //消息列表
      LinkmanList: [], //CRM联系人
      // 字母列表
      letter1: [],
      letter2: [],
      // 头部菜单
      menuList: [
        {
          index: "1",
          icon: "crm-yw-gl",
          text: this.$t("Header.menu1"),
          isAcitve: false,
        },
        {
          index: "2",
          icon: "crm-zs-crm",
          text: this.$t("Header.menu2"),
          isAcitve: true,
        },
        {
          index: "3",
          icon: "crm-home-",
          text: this.$t("Header.menu3"),
          isAcitve: false,
        },
        {
          index: "4",
          icon: "el-icon-setting",
          text: this.$t("Header.menu4"),
          isAcitve: false,
        },
      ],
      status: "", //判断是否可以切换至校务
      schoolOneInfo: {},
    };
  },
  components: {
    SliderBox,
    normalTableCont,
    userSeeing,
  },
  watch: {
    //用户信息监听
    Userinfomation(n) {
      //用户信息获取
      this.getUserInfo(n);
      let userInfo = n;
      this.$Tool.setStorage("marketer_id", userInfo.marketer_id);
      // this.$Tool.setStorage("school_id",userInfo.school_id);
      // this.$Tool.setStorage("company_id",userInfo.company_id);
      this.$Tool.setStorage("school_name", userInfo.school_cnname);
      // this.$Tool.setStorage("marketer_img", userInfo.marketer_img);
      this.$Tool.setStorage("token", userInfo.marketer_tokenencrypt);
      this.$store.dispatch("setUserToken", userInfo.marketer_tokenencrypt); //用户token
      this.$store.dispatch("setMarketerId", userInfo.marketer_id);
      // this.$store.dispatch('setSchoolId',userInfo.school_id); //存储schoolid
      // this.$store.dispatch('setCompanyId',userInfo.company_id);
      this.$store.dispatch("setUserInfo", n); //更新用户信息
    },
  },
  props: {
    isCollapse: {},
    hideMenu: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.SereachOneData();
    if (window.location.host == "crm.kedingdang.com") {
      this.isOffical = true;
    } else {
      this.isOffical = false;
    }
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.staffer_id = this.$Tool.getStorage("staffer_id");
    this.UserTooke = this.$Tool.getStorage("original_token");

    this.radioIndex = this.$Tool.getStorage("CURRENT_USER_POSTID"); //默认权限

    this.UserLinkId = this.$Tool.getStorage("staffer_id");
    this.status = this.$Tool.getStorage("status")
      ? this.$Tool.getStorage("status")
      : ""; //判断是否可以切换至校务
    if (
      this.$Tool.getStorage("schoolItem") != null &&
      !this.$route.query.staffer_id
    ) {
      this.school_id = this.$Tool.getStorage("school_id"); //已经选择的学校
    }
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    if (this.$store.state.USER_INFO) {
      var obj = Object.assign({}, this.$store.state.USER_INFO);
      //  obj.data=this.$store.state.USER_INFO;
      this.getUserInfo(obj);
    }
    this.getUserInfomation(); //获取用户个人信息
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(250); //设置表格高度

    this.timer = setInterval(() => {
      if (
        window.localStorage
          .getItem("token")
          .indexOf(this.$store.state.USER_TOKEN) < 0
      ) {
        clearInterval(this.timer);
        let timer = setTimeout(() => {
          clearTimeout(timer);
          window.location = "/";
        }, 300);
      }
    }, 1000);
  },
  computed: {
    moduleId() {
      return this.$store.state.module_id;
    },
    // username() {
    //   // let username = localStorage.getItem("ms_username");
    //   // return username ? username : this.name;
    // },
    Userinfomation() {
      return this.$store.state.USER_INFO;
    },
    activeIndex: {
      get: function () {
        return this.$store.state.navActiveIndex;
      },
      set: function () {},
    },
    showSliderNav() {
      return this.$store.state.showSliderNav;
    },
  },
  methods: {
    toggleShowNav() {
      this.$store.dispatch("setShowSliderNav", !this.showSliderNav);
    },
    handleColumnChange(k, v, column) {
      this.customerId = column.client_id;
      this.newclientTags = column.client_tag;
      this.activityId = column.activity_id;
      this.activeOne = column;
      this.filterName.visible = false;
      this.showSliderBoxSee = true;
    },
    SereachOneData() {
      storeAdmissionCue
        .SereachOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          keyword: this.selectForm.keyword,
        })
        .then((res) => {
          let columns = res.data.data.field;

          columns.forEach((v) => {
            if (v.fieldname == "client_cnname") {
              v.ismethod = 1;
            }
          });
          this.tableList.columns = columns;
          if (res.data.code === 200) {
            this.tableList.list = res.data.data.list;
          } else {
            this.tableList.list = [];
            this.tableList.options.errortip = res.data.msg;
          }
        });
    },
    handleSelectKeyword() {
      this.currentPage = 1;
      this.SereachOneData();
    },
    handleNameFocus() {
      this.filterName.visible = true;
    },
    viewDetail(v) {
      this.videoViewData.data = v;
      this.videoViewData.visible = true;
    },
    linkToChoose() {
      // let staffer_id = this.$Tool.getStorage("staffer_id");
      // let original_token = this.$Tool.getStorage("original_token");
      // window.location = `${this.$Urls.wpcUrl}/choose?token=${original_token}&staffer_id=${staffer_id}&company_id=${
      //   this.company_id
      // }&school_id=${this.school_id}`;
      this.ComTokenApi();
    },
    getModuleHandbookApi(type) {
      storeHeard
        .getModuleHandbookApi({
          module_id: this.moduleId,
          module_type: type,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const r = res.data.data;
            this.videoList = r.data != null ? r.data : r;
            if (type == 0) {
              this.showChooseTxt = true;
            } else if (type == 1) {
              this.showChooseVideo = true;
            }
          }
        });
    },
    showVideo() {
      if (this.moduleId) {
        this.getModuleHandbookApi(1);
      }
    },
    checkTxt() {
      if (this.moduleId) {
        this.getModuleHandbookApi(0);
      }
    },
    hideShowTxt() {
      this.showChooseTxt = !this.showChooseTxt;
    },
    showChooseTxtDetail() {
      this.hideShowTxtDetail = !this.hideShowTxtDetail;
    },
    checkDetail(id) {
      storeHeard
        .getModuleHandbookOneApi({
          handbook_id: id,
          module_id: this.moduleId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const r = res.data.data;
            const rows = r.data != null ? r.data : r;
            this.txtContent = rows[0];
            this.hideShowTxtDetail = true;
          }
        });
    },
    getChangeUrl(url) {
      storeHeard
        .ChangeUrl({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          url: url,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const body = res.data.data;
            this.$Tool.setStorage("module_id", body.module.module_id);
            this.$store.dispatch("setModuleId", body.module.module_id);
            var data = body.children;
            data.forEach((item) => {
              item.children.forEach((item1) => {
                if (item1.module_markurl == url) {
                  this.$Tool.setStorage("sliderActiveIndex", item1.activeIndex);
                  this.$store.dispatch("setActiveIndex", item1.activeIndex);
                  this.$Tool.setStorage("openMenu", ["" + item.index]);
                  this.$store.dispatch("setOpenMenu", ["" + item.index]);
                  this.$router.push(url);
                }
              });
            });
          }
        });
    },
    // 获取用户信息
    getUserInfo(n) {
      if (n) {
        this.userName = n.marketer_name;
        // this.LogoImg = n.company_logo;
      } else {
        this.userName = "";
      }
      if (this.$Tool.getStorage("schoolItem")) {
        this.school = this.$Tool.getStorage("schoolItem");
      } else {
        this.school = n.school_cnname; // 默认的学校
      }
    },
    // CRM-联系人
    getLinkmanData() {
      storeHeard
        .getLinkman({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.LinkmanList = res.data.data.data;
          if (this.LinkmanList != undefined) {
            var list1 = [];
            this.LinkmanList.forEach((item) => {
              var department = "",
                department_id = "";
              var arr1 = {};
              var list2 = [];
              item.forEach((item1) => {
                var arr2 = {};
                department = item1.post_name;
                department_id = item1.post_id;
                arr2 = item1;
                list2.push(arr2);
              });
              arr1.departmentName = department;
              arr1.departmentId = department_id;
              arr1.list = list2;
              list1.push(arr1);
            });
            this.LinkmanList = list1;
          }
        });
    },
    //获取用户个人信息
    getUserInfomation() {
      storeHeard
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          var user = res.data.data.data[0];
          if (user) {
            this.myinfoform = {
              marketer_name: user.marketer_name,
              staffer_sex: user.staffer_sex,
              staffer_birthday: user.staffer_birthday,
              marketer_img: user.marketer_img,
              staffer_branch: user.staffer_branch,
              marketer_mobile: user.marketer_mobile,
            };
            this.LogoImg = user.company_logo;
            // company_ismajor  0是免费版 1是普通版   2是专业版
            this.$Tool.setStorage("company_ismajor", user.company_ismajor);
            this.$store.dispatch("set_companyIsmajor", user.company_ismajor);
            this.$store.dispatch("set_companyIsassist", user.company_isassist);
            // isopennearschool: "是否开启附件学校：1开启0为开启"
            this.$Tool.setStorage("isopennearschool", user.isopennearschool);
            this.$store.dispatch(
              "setCompanyIsNoIntention",
              user.company_isnointention == 1
            );
            this.$store.dispatch(
              "setSeatsIntentionLevel",
              user.seats_intentionlevel
            );
          }
        });
    },
    // 大区域 -- 筛选区域
    getDistrictData() {
      storeHeard
        .getDistrict({
          company_id: this.company_id,
        })
        .then((res) => {
          this.areaList = res.data.data.data;
          this.areaList.unshift({
            district_id: "-1",
            district_cnname: this.$t("Common.options"),
          });
        });
    },
    // 获取省份
    getProvinceData() {
      // 获取省份
      storeHeard.getProvince({}).then((res) => {
        this.provinceList = res.data.data.data;
      });
    },
    // 获取城市
    getCityData() {
      // 获取省份
      this.getSchoolData(1);
      this.form.city = "";
      storeHeard
        .getCity({
          region_id: this.form.province,
        })
        .then((res) => {
          this.cityList = res.data.data.data;
        });
    },
    //获取学校
    getSchoolData(isSelect) {
      // isSelect=0//不筛选
      // isSelect=1//筛选
      var data;
      if (isSelect == 0) {
        //不筛选
        data = {
          marketer_id: this.marketer_id,
          token: this.token,
          keyword: this.form.keyword,
        };
      } else if (isSelect == 1) {
        // 筛选
        data = {
          marketer_id: this.marketer_id,
          token: this.token,
          keyword: this.form.keyword,
          school_province: this.form.province,
          school_city: this.form.city,
          district_id: this.form.district_id,
        };
      } else {
        // 筛选
        data = {
          marketer_id: this.marketer_id,
          token: this.token,
          keyword: this.form.keyword,
          school_province: this.form.province,
          school_city: this.form.city,
          school_cnname_initial: this.form.letter,
        };
      }
      storeHeard.getSchool(data).then((res) => {
        console.log(res, 'res---res');
        this.schoolList = res.data.data.data;
        if (this.schoolList != undefined) {
          var list1 = [];
          var letter = res.data.data.initial;
          this.schoolList.forEach((item) => {
            var company_name = "",
              company_id = "";
            var arr1 = {};
            var list2 = [];
            item.forEach((item1) => {
              var arr2 = {};
              company_name = item1.company_cnname;
              company_id = item1.company_id;
              arr2.school_shortname = item1.school_shortname;
              arr2.school_id = item1.school_id;
              arr2.school_cnname = item1.school_cnname;
              arr2.school_branch = item1.school_branch;
              arr2.postbe_id = item1.postbe_id;
              arr2.status = item1.status;
              arr2.school_isgrayscalecrm = item1.school_isgrayscalecrm;
              list2.push(arr2);
            });
            arr1.companyName = company_name;
            arr1.company_id = company_id;
            arr1.list = list2;
            list1.push(arr1);
          });
          this.schoolList = list1;
          //字母显示
          this.letter1 = []; //清空
          this.letter2 = [];
          letter.forEach((item, index) => {
            if (index < letter.length / 2) {
              this.letter1.push(item);
            } else {
              this.letter2.push(item);
            }
          });
        }
      });
    },
    // 获取职工所属学校组织
    getSchooOrganizelData() {
      storeHeard
        .getSchooOrganizel({
          marketer_id: this.marketer_id,
          token: this.token,
        })
        .then((res) => {
          this.organizationList = res.data.data.data;
        });
    },
    // 选择城市后筛选学校
    SelectCity() {
      this.getSchoolData(1);
    },
    // 选择机构组织后筛选学校
    SelectOrganiza() {
      if (this.form.district_id == "-1") {
        this.form.district_id = "";
      }
      this.getSchoolData(1);
    },
    // 输入关键词筛选学校
    SelectKeyword() {
      this.getSchoolData(1);
    },
    // 字母筛选学校
    SelectLetter(v) {
      this.form.letter = v;
      this.getSchoolData(2);
    },
    // 点击显示学校
    showSchool() {
      this.current = -1;
      this.schoolList = []; //数据初始化
      this.getSchoolData(0);
      this.getProvinceData(); //获取省份列表
      this.getSchooOrganizelData(); //获取职工所属学校组织
      this.getDistrictData(); //获取大区域
      this.selectSchool = true;
    },
    // 切换职位
    choosePost() {
      let id = this.$Tool.getStorage("CURRENT_USER_POSTID");
      if (this.radioIndex != id) {
        let allAccounts = this.$Tool.getStorage("USER_ALL_ACCOUNTS");
        var $radioIndex = this.radioIndex;
        allAccounts.forEach((e) => {
          if (e.postbe_id == $radioIndex) {
            this.$Tool.setStorage("CURRENT_USER_ACCOUNTS", e);
          }
        });
        this.$Tool.setStorage("IS_CHANGE", true);
        //this.getOwnInfoApi();
        this.exchangeRoleVis = false;
        window.location = `${this.$Urls.wpcUrl}/choose?token=${this.UserTooke}&staffer_id=${this.UserLinkId}&company_id=${this.company_id}&school_id=${this.school_id}`;
      } else {
        this.$message.error("请切换至帐号其他角色！");
      }
    },
    resetData() {
      this.radioIndex = this.$Tool.getStorage("CURRENT_USER_POSTID");
    },
    // 页面跳转
    linkToCRM() {
      // window.location.href = `${this.$Urls.crmUrl}/havePermission?staffer_id=${this.UserLinkId}&token=${this.UserTooke}`
      this.getChangeUrl("/home");
    },
    linkToGMC() {
      // window.location.href = `${this.$Urls.gmcUrl}/havePermission?staffer_id=${
      //   this.UserLinkId
      // }&token=${this.UserTooke}&school_id=${this.school_id}&company_id=${
      //   this.company_id
      // }`;
      this.linkToGmcToken();
    },
    linkToSMC() {
      // window.location.href = `${this.$Urls.smcUrl}/havePermission??staffer_id=${
      //   this.UserLinkId
      // }&token=${this.UserTooke}&school_id=${this.school_id}&company_id=${
      //   this.company_id
      // }`;
      this.linkComTokenApi();
    },
    oninfoSubmit() {
      this.showMyinfo = false;
    },
    hideMemessageBox() {
      this.showMemessage = false;
    },
    hideshowContactBox() {
      this.showContact = false;
    },
    hideshowMyinfoBox() {
      this.showMyinfo = false;
    },
    //导航栏模块选择
    handleSelect(key) {
      var arr = this.menuList;
      arr.forEach((item) => {
        item.isAcitve = false;
      });
      arr[key - 1].isAcitve = true;
      this.menuList = [];
      this.menuList = arr;
      if (key == "1") {
        this.linkToSMC();
      } else if (key == "2") {
        this.$Tool.setStorage("navActiveIndex", "2");
        this.$store.dispatch("setNavActiveIndex", "2");
        this.getChangeUrl("/home");
      } else if (key == "3") {
        this.$Tool.setStorage("navActiveIndex", "3");
        this.$store.dispatch("setNavActiveIndex", "3");
        this.$router.push("/Websitebuilding");
      } else if (key == "4") {
        this.$Tool.setStorage("navActiveIndex", "4");
        this.$store.dispatch("setNavActiveIndex", "4");
        this.$router.push("/Websitebuilding");
      }
    },
    linkComTokenApi() {
      this.$http.ComTokenApi({}).then((res) => {
        if (res.data.code === 200) {
          let token = res.data.data.token;
          location.href = buildSystemHavePermissionUrl(this.$Urls.smcUrl, {
            staffer_id: this.staffer_id,
            token,
            school_id: this.school_id,
            company_id: this.company_id,
            language: this.languageType,
            postbe_id: this.$Tool.getStorage(STORAGE_KEYS.RE_POSTBE_ID),
          });
        }
      });
      // axios
      //   .get(`${this.$Urls.wpcApiUrl}/Login/ComTokenApi`, {
      //     params: {},
      //   })
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       let token = res.data.token;
      //       location.href = `${this.$Urls.smcUrl}/havePermission??staffer_id=${
      //         this.staffer_id
      //       }&token=${token}&school_id=${this.school_id}&company_id=${
      //         this.company_id
      //       }&language=${this.languageType}&postbe_id=${this.$Tool.getStorage(
      //         "re_postbe_id"
      //       )}`;
      //     }
      //   });
    },
    linkToGmcToken() {
      this.$http.ComTokenApi({}).then((res) => {
        if (res.data.code === 200) {
          let token = res.data.token;
          location.href = buildSystemHavePermissionUrl(this.$Urls.gmcUrl, {
            staffer_id: this.staffer_id,
            token,
            school_id: this.school_id,
            company_id: this.company_id,
            language: this.languageType,
            postbe_id: this.$Tool.getStorage(STORAGE_KEYS.RE_POSTBE_ID),
          });
        }
      });

      // axios
      //   .get(`${this.$Urls.wpcApiUrl}/Login/ComTokenApi`, {
      //     params: {},
      //   })
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       let token = res.data.token;
      //       location.href = `${this.$Urls.gmcUrl}/havePermission??staffer_id=${
      //         this.staffer_id
      //       }&token=${token}&school_id=${this.school_id}&company_id=${
      //         this.company_id
      //       }&language=${this.languageType}&postbe_id=${this.$Tool.getStorage(
      //         "re_postbe_id"
      //       )}`;
      //     }
      //   });
    },
    ComTokenApi() {
      this.$http.ComTokenApi({}).then((res) => {
        if (res.data.code === 200) {
          let token = res.data.data.token;
          this.getUserStatusInfo(token);
        }
      });
      // axios
      //   .get(`${this.$Urls.wpcApiUrl}/Login/ComTokenApi`, {
      //     params: {},
      //   })
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       let token = res.data.token;
      //       this.getUserStatusInfo(token);
      //     }
      //   });
    },
    getUserStatusInfo(token) {
      this.$http.ChangePostApi({}).then((res) => {
        if (res.data.code === 200) {
          const { isAdmin, status } = res.data.data;
          // window.localStorage.clear();
          location.href = buildChooseUrl(this.$Urls.wpcUrl, {
            token,
            staffer_id: this.staffer_id,
            company_id: this.company_id,
            school_id: this.school_id,
            status,
            isAdmin,
            marketer_id: this.marketer_id,
            language: this.languageType,
          });
        }
      });
      // axios
      //   .get(`${this.$Urls.wpcApiUrl}/Login/ChangePostApi`, { params: {} })
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       const { isAdmin, status } = res.data;
      //       window.localStorage.clear();
      //       location.href = `${this.$Urls.wpcUrl}/choose?token=${token}&staffer_id=${this.staffer_id}&company_id=${this.company_id}&school_id=${this.school_id}&status=${status}&isAdmin=${isAdmin}&marketer_id=${this.marketer_id}&language=${this.languageType}`;
      //     }
      //   });
    },
    // 获取 权限列表*****postbe_crmuserlevel=1
    getModule() {
      storeHeard
        .getModule({
          module_class: 3,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const children = res.data.data.children;
            const school_cnname = res.data.data.school_cnname;
            this.$Tool.setStorage("Slider", children);
            this.$store.dispatch("setSlider", children);
            this.$Tool.setStorage("schoolItem", school_cnname);
            location.href = "/home";
          }
        });
    },
    // 获取 权限列表*****postbe_crmuserlevel=0
    getLowModuleList() {
      storeHeard
        .getLowModuleList({
          module_class: 3,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const children = res.data.data.children;
            const school_cnname = res.data.data.school_cnname;
            this.$Tool.setStorage("Slider", children);
            this.$store.dispatch("setSlider", children);
            this.$Tool.setStorage("schoolItem", school_cnname);
            location.href = "/home";
          }
        });
    },
    // 切换语言下拉菜单选择事件
    handleCommandLanguage(command) {
      // 切换语言
      this.languagType = command;
      this.$Tool.setStorage("language", command);
      this.$Tool.setStorage("openMenu", ["0"]);
      this.$Tool.setStorage("sliderActiveIndex", "0-1");
      if (this.postbe_crmlevel == "1") {
        this.getModule(); // 获取 权限列表*****postbe_crmuserlevel=1
      } else {
        this.getLowModuleList(); // 获取 权限列表*****postbe_crmuserlevel=0
      }
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        // localStorage.removeItem("original_token");
        // localStorage.removeItem("school_id");
        // localStorage.removeItem("token");
        // localStorage.removeItem("staffer_id");
        // localStorage.removeItem("company_id");
        // localStorage.removeItem("userInfo");
        // localStorage.removeItem("marketer_id");
        // localStorage.removeItem("token");
        window.localStorage.clear();
        window.location.href = `${this.$Urls.wpcUrl}/login`;
        // this.$router.push("/");
      } else if (command == "contact") {
        this.getLinkmanData(); // CRM-联系人
        this.showContact = true;
      } else if (command == "exchange") {
        // this.role_list = this.$Tool.getStorage("USER_ALL_ACCOUNTS");
        // this.exchangeRoleVis = true; //切换职务
        // this.getUserStatusInfo();
        this.ComTokenApi();
      } else {
        this.showMyinfo = true; //个人信息
        this.getUserInfomation();
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.$emit("toggleCollapse", !this.isCollapse);
    },
    //弹框关闭
    handleClose(done) {
      this.$confirm(this.$t("Common.closeTips"))
        .then(() => {
          // 数据初始化
          this.form = {
            province: "",
            city: "",
            organization: "",
            district_id: "",
            keyword: "",
            letter: "",
          };
          done();
        })
        .catch(() => {});
    },
    handhideSchool() {
      // 数据初始化
      this.form = {
        province: "",
        city: "",
        organization: "",
        district_id: "",
        keyword: "",
        letter: "",
      };
      this.selectSchool = false;
    },
    //学校选择
    selSchool(key1, key2, item1, item2) {
      this.current = key2;
      this.pagecurrent = key1;
      this.schoolItem = item2.school_shortname;
      this.schoolId = item2.school_id;
      this.companyId = item1.company_id;
      this.postbe_id = item2.postbe_id ? item2.postbe_id : 0;
      this.schoolOneInfo = item2;
    },
    dbSelSchool(key1, key2, item1, item2) {
      this.current = key2;
      this.pagecurrent = key1;
      this.schoolItem = item2.school_shortname;
      this.schoolId = item2.school_id;
      this.companyId = item1.company_id;
      this.postbe_id = item2.postbe_id ? item2.postbe_id : 0;
      this.schoolOneInfo = item2;
      this.HandleButton();
    },
    // // 获取 权限列表(切换职务)
    getCrmLevel(id) {
      storeHeard
        .getCrmLevel({
          module_class: 3,
          postbe_id: id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            let { children } = res.data.data;
            this.$Tool.setStorage("Slider", children);
            this.$Tool.setStorage(
              "PostbeCrmlevel",
              res.data.data.level.postbe_crmuserlevel
            );
            this.$Tool.setStorage("sliderActiveIndex", "0-1");
            this.$Tool.setStorage("openMenu", ["0"]);
            this.$Tool.setStorage("navActiveIndex", "2");
            this.$store.dispatch("setNavActiveIndex", "2");

            if (this.istemporaryclose) {
              this.$Tool.setStorage(
                "SchoolTemporaryCloseTip",
                this.temporaryclosetip
              );
              window.location = "/temporaryClosure";
            } else {
              window.location.href = "/home"; //刷新页面
            }
          }
        });
    },
    HandleButton() {
      this.selectSchool = false;
      // 数据初始化
      this.form = {
        province: "",
        city: "",
        organization: "",
        district_id: "",
        keyword: "",
        letter: "",
      };
      if (this.schoolItem != "") {
        this.$http
          .addStafferSchoolAction({
            newschool_id: this.schoolId,
          })
          .then((res) => {
            const { code, msg, data: body } = res.data;
            const school = body.school;
            if (code === 200) {
              this.school = this.schoolItem;
              this.status = applySchoolSwitchContext({
                Tool: this.$Tool,
                store: this.$store,
                schoolItem: this.schoolItem,
                schoolId: this.schoolId,
                companyId: this.companyId,
                postbeId: this.postbe_id,
                schoolOneInfo: this.schoolOneInfo,
              }); //判断是否可以切换至校务
              this.school_id = this.schoolId;
              this.company_id = this.companyId;

              this.istemporaryclose = school.school_istemporaryclose == 1;
              this.temporaryclosetip = school.school_temporaryclosetip;

              this.getCrmLevel(this.postbe_id);
              // location.reload(); //刷新页面
              // window.location.href = "/home"; //刷新页面
            } else {
              this.$message.error(msg);
            }
          });
      }
    },
    // 刷新
    Refresh() {
      this.rotate = !this.rotate;
      let timer = setTimeout(() => {
        // location.reload();
        this.selectSchool = true;
        clearTimeout(timer);
      }, 2000);
    },
  },
  mounted() {
    if (document.body.clientWidth < 1000) {
      this.collapseChage();
    }

    //兼容性写法，该函数也是网上别人写的，不过找不到出处了，蛮好的，所有我也没有必要修改了
    //判断鼠标滚轮滚动方向
    if (window.addEventListener)
      //FF,火狐浏览器会识别该方法
      window.addEventListener("DOMMouseScroll", wheel, false);
    window.onmousewheel = document.onmousewheel = wheel; //W3C
    //统一处理滚轮滚动事件
    function wheel(event) {
      var delta = 0;
      if (!event) event = window.event;
      if (event.wheelDelta) {
        //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
        delta = event.wheelDelta / 120;
        if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
      } else if (event.detail) {
        //FF浏览器使用的是detail,其值为“正负3”
        delta = -event.detail / 3;
      }
      if (delta) handle(delta);
    }
    //上下滚动时的具体处理函数
    function handle(delta) {
      if (delta < 0) {
        //向下滚动
        // _this.showSliderNav = false;
      } else {
        //向上滚动
        // _this.showSliderNav = true;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.choose_video__list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  // justify-content: space-between;
  align-items: center;
  .vitem {
    width: 32%;
    height: 200px;
    margin-right: 2%;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    video,
    img {
      display: block;
      width: 100%;
      height: 140px;
    }
    p {
      padding-top: 5px;
      font-size: 16px;
      color: #666;
    }
  }
}
.view_video__container {
  video {
    width: 100%;
    height: 100%;
    display: flex;
  }
}
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  font-size: 16px;
  color: #333;
  background: #f0f4fa;
  display: flex;

  .el-menu {
    background: #f0f4fa;
  }

  .icon-menu {
    display: inline-block;
    width: 36px;
    height: 25px;
    margin-top: 18%;

    img {
      width: 100%;
    }
  }
}

.head-line {
  float: left;
  border: 0.6px solid #ddd;
  height: 20px;
  margin-top: 25px;
}

.page-header {
  .filterName {
    margin-right: 20px;
    width: 144px;
    height: 30px;
    /deep/.el-input__inner {
      border-radius: 15px !important;
    }
  }
  .slider-title {
    margin-left: 46%;
  }

  .btn-back {
    cursor: pointer;

    i {
      display: inline-block;
      height: 50px;
      line-height: 50px;
    }
  }

  .btn-back + p {
    margin-left: 43%;
  }

  .slider-title + div {
    i {
      display: inline-block;
      height: 50px;
      line-height: 50px;
    }
  }

  .silder-contain .slider-top {
    border-bottom: none;
  }

  .silder-contain .slider-top-info {
    border-bottom: 1px solid #ddd;

    .slider-title {
      margin-left: 0px;
    }
  }

  .silder-contain .slider-cont {
    padding: 0px 0px 0px 0px;

    .message-title {
      background: #f4f5f7;
      height: 40px;
      line-height: 40px;
      padding: 0px 20px;
    }

    .row-message {
      padding: 10px 20px;
      border-bottom: 1px solid #ddd;

      .message-cont {
        line-height: 24px;

        span {
          display: inline-block;
          margin-right: 10px;
        }

        span + span {
          color: #20a8d8;
          cursor: pointer;
        }
      }
    }

    .span-message {
      display: inline-block;
      background: #20a8d8;
      color: #fff;
      margin-bottom: 5px;
      padding: 2px 5px;
      border-radius: 3px;
      font-size: 12px;
    }

    .sapn-warning {
      background: #f8cb00;
    }
  }

  .contact {
    padding: 0px 20px;

    .row-contact:nth-last-of-type(1) {
      border-bottom: none;
    }
  }

  .contact-cont {
    padding-top: 20px;
  }

  .contact-cont > p {
    background: #f4f5f7;
    height: 40px;
    line-height: 40px;
    padding: 0px 20px;
  }

  .row-contact {
    padding: 10px 0px;
    border-bottom: 1px solid #ddd;

    .name {
      margin-bottom: 5px;

      > span {
        display: inline-block;
        background: #20a8d8;
        color: #fff;
        margin-left: 15px;
        padding: 0px 8px;
        border-radius: 3px;
        font-size: 12px;
      }
    }

    .grid-img {
      width: 40px;
      height: 40px;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.collapse-btn {
  // float: left;
  padding: 0px;
  cursor: pointer;
  line-height: 60px;
}

.header-middle {
  flex: 1;
  display: flex;
  justify-content: center;
  .el-menu-item i {
    display: inline-block;
    margin-right: 5px;
    font-size: 16px;
  }

  .el-menu .is-active {
    i:before {
      color: #20a8d8;
    }
  }
}

.el-tooltip {
  color: #fff;
}

.el-badge {
  margin-left: 10px;
}

.el-badge > i {
  vertical-align: middle;
  line-height: 1.5;
  font-size: 24px;
  color: #b7b7b7;
  cursor: pointer;
}

.header .logo {
  float: left;
  width: 234px;
  padding: 0px 0px 0px 6px;
  line-height: 60px;
  height: 60px;
  display: flex;
  align-items: center;
}

.header .logo img {
  display: inline-block;
  max-height: 40px;
  max-width: 120px;
  margin-top: 0;
  // margin-right: 10px
}

.header .logo span {
  float: right;
  margin-left: 8px;
  font-size: 16px;
}

.header-right {
  // float: right;
  padding-right: 50px;
}

.header-user-con {
  display: flex;
  height: 60px;
  align-items: center;
}
// 语言切换
.languag-change {
  margin-right: 10px;
  padding: 0 10px;
  line-height: 28px;
  border-radius: 14px;
  font-weight: bold;
  color: #333;
  background-color: #fff;
  // background-color: #f2f4f7;
  span {
    cursor: pointer;
  }
  .active {
    color: #20a8d8;
  }
  .line {
    border: 1px solid #ddd;
    margin: 0 6px;
  }
}

.btn-fullscreen {
  /* transform: rotate(45deg); */
  margin-right: 5px;
  font-size: 14px;
  padding: 0px 10px;
  background: #20a8d8;
  line-height: 24px;
  color: #fff;
  max-width: 188px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  height: 24px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

.user-name {
  margin-left: 10px;
  cursor: pointer;
  .dropdown-title {
    display: flex;
    > span {
      line-height: 40px;
    }
  }
}

.user-avator {
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}

.el-menu {
  background-color: #fff;
  border: none;
}

.el-menu--horizontal > .el-menu-item {
  height: 60px;
  line-height: 60px;
  color: #333;
}

.el-menu--horizontal > .el-menu-item:hover {
  background-color: #f1f4fb;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: #20a8d8;
  // font-weight: bold;
}

.el-dropdown-link {
  color: #333;
}

.btn-bell span i {
  vertical-align: middle;
  line-height: 1.5;
  font-size: 20px;
}

.btn-more {
  position: absolute;
  right: 0;
  top: 35%;
  z-index: 500;

  a {
    width: 44px;
    display: inline-block;
    height: 65px;
    position: absolute;
    right: 0%;
  }
}

.right-slider-box {
  .slider-header {
    padding: 20px 20px;
    border-bottom: 1px solid #ccc;
    text-align: center;

    span {
      font-weight: 500;
    }

    i {
      font-size: 28px;
      display: inline-block;
    }
  }

  .slider-cont {
    padding: 20px 20px;

    .info-title {
      text-align: center;
      font-weight: 500;
      margin-bottom: 5px;
    }

    > p {
      line-height: 26px;
    }

    .info-small-title {
      text-align: center;
    }

    .text-content {
      letter-spacing: 3px;
    }

    .info-img {
      width: 100%;
      border-radius: 6px;
      margin: 20px auto;

      img {
        width: 100%;
      }
    }
  }
}

//选择样式
.aa {
  transition: all 2s;
}

.go {
  transform: rotate(-180deg);
  transition: all 2s;
}

@media (max-width: 1280px) {
  .header .el-menu-item {
    padding: 0 15px;
  }
}
</style>

<style lang="less">
// 修改公共组件样式
// 选择学校的样式
.tan-select-school {
  .el-dialog {
    padding: 0px 20px;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 26px;
    }

    .el-dialog__header {
      padding: 12px 0px;
    }

    .el-dialog__body {
      padding: 10px 0px;
    }
  }

  .el-form {
    // border-top: 1px solid #ddd;
    padding: 10px 0px 20px 0px;
    border-bottom: 1px solid #ddd;
  }

  .title-cont {
    font-size: 16px;
    font-weight: 500;
    color: rgba(170, 170, 170, 1);
    margin-bottom: 10px;
  }

  .school {
    max-height: 250px;
    overflow-y: auto;
  }

  .school-list {
    width: 90%;

    .title {
      font-size: 15px;
      color: rgba(170, 170, 170, 1);
      margin-bottom: 10px;
    }

    .list-item {
      padding: 10px 0px;
      border-bottom: 1px solid #ddd;

      ul {
        li {
          height: 26px;
          line-height: 26px;
          cursor: pointer;
          font-size: 13px;
        }

        .active {
          color: #20a8d8;
        }
      }
    }

    .list-item:nth-last-of-type(1) {
      border: none;
    }
  }

  .letter {
    width: 45px;
    padding: 10px 0px;
    padding-top: 40px;

    > ul {
      display: inline-block;
    }

    > ul > li {
      cursor: pointer;

      span {
        display: inline-block;
      }

      height: 24px;
      line-height: 24px;
    }

    ul + ul {
      margin: 0px 10px;
    }
  }
}

// 个人信息
.myinfo-slider-cont {
  .el-form {
    padding: 20px 20px 0px 20px !important;
  }

  .upload-demo .el-upload-dragger {
    width: 300px;
    background: #fafafa;
    // padding-top: 15%;
    padding: 10px;
    display: flex;
    justify-items: center;
    align-items: center;
    img {
      margin: 0 auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  // .myinfo-photo-img{

  // }

  .el-upload-dragger .el-upload__text {
    line-height: 26px;
  }
}
//悬浮框
.slider_nav_box {
  position: fixed;
  bottom: 50px;
  width: 56px;
  // height: 300px;
  padding: 18px 0;
  background-color: #fff;
  box-shadow: 0px 0px 26px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px 0 0 10px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  transition: all 0.3s;
  .items {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    .icon {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
    }
    .icon_0 {
      width: 24px;
      height: 24px;
      background-image: url(../../assets/images/sliderNav/nav_0_icon.jpg);
    }
    .icon_1 {
      width: 24px;
      height: 21px;
      background-image: url(../../assets/images/sliderNav/nav_1_icon.png);
    }
    .icon_2 {
      width: 24px;
      height: 17px;
      background-image: url(../../assets/images/sliderNav/nav_2_icon.png);
    }
    .icon_3 {
      width: 24px;
      height: 24px;
      background-image: url(../../assets/images/sliderNav/nav_3_icon.png);
    }
    .icon_4 {
      width: 19px;
      height: 22px;
      background-image: url(../../assets/images/sliderNav/nav_4_icon.png);
    }
    .txt {
      padding-top: 3px;
      font-size: 12px;
      color: #333;
      line-height: 16px;
    }
  }

  .arrow {
    position: absolute;
    left: -28px;
    top: 20px;
    width: 28px;
    height: 30px;
    background-color: #20a8d8;
    border-radius: 25px 0 0 25px;
    font-size: 14px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 0px 26px 0px rgba(0, 0, 0, 0.1);
  }
}
// 切换职务
.role__list {
  padding-bottom: 40px;
  .role_list__head {
    display: flex;
    padding-top: 10px;
    align-items: center;
    font-size: 14px;
    color: #55606e;
    .h_lf {
      width: 55%;
    }
    em {
      color: #f35c5c;
    }
  }
  .role_list__cont {
    padding-top: 15px;
    position: relative;
    .items {
      display: flex;
      margin-bottom: 15px;
      align-items: center;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        width: 55%;
        p {
          display: inline-block;
          padding: 0 8px;
          margin-right: 40px;
          line-height: 24px;
          color: #fff;
          background-color: #d8d8d8;
          border-radius: 3px;
        }
      }
    }
  }
  .exchange_btn {
    position: absolute;
    right: 60px;
    top: 10px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1500px) {
  .page-header .header .header-middle {
    width: 36%;
  }
  .page-header .header-middle .el-menu .el-menu-item {
    padding: 0 15px !important;
  }
  .page-header .header .header-right {
    padding-right: 26px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1300px) {
  .page-header .header .header-middle {
    width: 36%;
  }
  .page-header .header-middle .el-menu .el-menu-item {
    padding: 0 10px !important;
  }
  .page-header .header .header-right {
    padding-right: 20px;
  }
  .page-header .btn-fullscreen {
    max-width: 150px;
  }
}
.info-content {
  img {
    max-width: 100%;
    width: 100%;
  }
}
.download_files {
  display: inline-block;
  font-size: 16px;
  padding: 15px 0 0;
  color: #20a8d8;
}
.listSearch-container {
  .content {
    // .el-table__body .el-table__row td:nth-of-type(2) {
    //   color: #20a8d8;
    // }

    // .follow-class .el-table__body .el-table__row td:nth-of-type(2) {
    //   color: #333;
    // }

    .el-select {
      width: 140px;

      .el-input--suffix .el-input__inner {
        padding-right: 20px;
      }
    }

    .input-cont {
      width: 180px;
    }

    .btn-inquire {
      margin-right: 10px;
      padding: 7px 10px !important;
    }

    .family-phone {
      margin-right: 0px;
    }
  }

  .content-nav--head {
    // display: block;
    .nav-top {
      margin-bottom: 10px;

      .el-button + .el-button {
        margin-right: 20px;
      }
    }
  }
}
</style>
